import { ProductTour } from 'components/ProductTour/ProductTour'
import { CardinalOrientation, Step } from 'walktour'
import { TourProps, TourStartCard } from '../Types'
import { getScrollParent } from '@react-aria/utils'

const steps: Step[] = [
  {
    selector: '.blog-post-output-tour-1',
    title: 'Let your story shine',
    description: 'Edit your post with different brand voices and tones so it sounds just right.',
    orientationPreferences: [CardinalOrientation.WEST],
  },
  {
    selector: '.blog-post-output-tour-2',
    title: 'Get discovered',
    description: 'Find the best keywords and article structures to rank on Google.',
  },
  {
    selector: '.blog-post-output-tour-3',
    title: 'Hello, world!',
    description: 'Schedule your post to appear automatically on your website.',
  },
  {
    selector: '.blog-post-output-tour-4',
    title: 'Amplify your ideas',
    description: 'Transform this post into posts for Instagram, Facebook, LinkedIn, X (Twitter), TikTok, and more.',
  },
]

const startCard: TourStartCard = {
  title: 'Craft High-Impact Blog Posts',
  content: 'Create SEO-optimized posts that attract readers.',
}

const beforeStart = () => {
  const scrollToTop = (el: HTMLElement | null) => {
    if (el) {
      const scrollParent = getScrollParent(el)
      if (scrollParent) {
        scrollParent.scrollTop = 0
      }
    }
  }

  scrollToTop(document.querySelector('.blog-post-output-tour-1'))
  scrollToTop(document.querySelector('.blog-post-output-tour-3'))
}

export const BlogPostOutputTour = (props: TourProps) => {
  return (
    <ProductTour tour="blog_post_output" steps={steps} {...props} startCard={startCard} beforeStart={beforeStart} />
  )
}
